import { EnumOrganizationPermissions } from '@/helpers/enums/permissions.enum';

export const financials = {
  cartPage: {
    name: 'Cart Page',
    path: '/cart',
    title: 'cart.myShoppingCart',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      organizationPermissions: [EnumOrganizationPermissions.Marketplace],
    },
  },
  myPurchases: {
    name: 'My Purchases',
    path: '/my-purchases',
    title: 'menu.myPurchases',
    icon: 'mdi-wallet-outline',

    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      organizationPermissions: [EnumOrganizationPermissions.Marketplace],
    },
  },
  myWallet: {
    name: 'My wallet',
    path: '/my-purchases/my-wallet',
    title: 'wallet.MyWallet',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      organizationPermissions: [
        EnumOrganizationPermissions.Marketplace,
        EnumOrganizationPermissions.Wallet,
      ],
    },
  },
  paymentHistory: {
    name: 'Payment History',
    title: 'menu.paymentHistory',
    icon: 'mdi-cash',
    path: '/my-purchases/payment-history',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Payment History`,
      requiresAuth: true,
      organizationPermissions: [EnumOrganizationPermissions.Marketplace],
    },
  },
  singleOrder: {
    name: 'Single Order',
    title: 'menu.singleOrder',
    path: '/my-purchases/payment-history/:orderId',
    pathFn: (orderId: string | number) =>
      `/my-purchases/payment-history/${orderId}`,
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Order's Detail`,
      requiresAuth: true,
      organizationPermissions: [EnumOrganizationPermissions.Marketplace],
    },
  },
  paymentCompleteRedirect: {
    name: 'Redirect to Dashboard',
    path: '/payment-complete',
    title: 'header.verifyingPayment',
    icon: 'mdi-view-dashboard-outline',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Verifying Payment`,
      requiresAuth: true,
      // No permission gate: payment verification is owner-scoped (the nest
      // endpoint checks order ownership), and the route is reachable from
      // any paid feature (courses, events, wallet). The marketplace flag is
      // the right org-level gate — if the org can sell, this landing works.
      organizationPermissions: [EnumOrganizationPermissions.Marketplace],
      dontUseKey: false,
    },
  },
};
